import * as React from 'react';

type CheckBoxInputProps = {
  className?: string;
  name: string;
  id?: string;
  disabled?: boolean;
  error?: boolean;
  value: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

function CheckBoxInput({
  className,
  name,
  id,
  disabled,
  error,
  checked,
  value,
  onChange,
}: CheckBoxInputProps) {
  return (
    <input
      style={{ boxShadow: 'none' }}
      className={`${className} ${error ? 'text-river-red' : ''} `}
      type="checkbox"
      name={name}
      id={id}
      disabled={disabled}
      value={value}
      onChange={onChange}
      checked={checked}
    />
  );
}

CheckBoxInput.defaultProps = {
  className: '',
  id: '',
  disabled: false,
  error: false,
};

export default CheckBoxInput;
